module.exports = __webpack_public_path__ + "static/media/goten-polar4-1.136a1e62.wav";